import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { UserQualificationV2Attachment } from '@wilson/interfaces';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { stringify } from 'qs';
import { Observable } from 'rxjs';

export interface DeleteUserQualificationV2AttachmentDto {
  ids: string[];
}

@Injectable({
  providedIn: 'root',
})
export class UserQualificationsV2AttachmentGatewayService {
  protected readonly http = inject(HttpClient);
  protected readonly config = inject<ConfigOptions>(ConfigService);

  private readonly path = `${this.config.host}/v2/users/qualifications/attachments`;

  public addAttachments(
    filesToUpload: NzUploadFile[] | File[],
    userQualificationIds: string[],
  ): Observable<UserQualificationV2Attachment[]> {
    const formData = new FormData();
    for (const file of filesToUpload) {
      formData.append('files', file as unknown as File);
    }
    const queryParams = {
      userQualificationIds: userQualificationIds,
    };
    const queryString = stringify(queryParams, {
      arrayFormat: 'brackets',
      addQueryPrefix: true,
    });

    return this.http.post<UserQualificationV2Attachment[]>(
      `${this.path}${queryString}`,
      formData,
    );
  }

  public deleteAttachments(idsToDelete: string[]): Observable<{
    count: number;
  }> {
    const queryParams = {
      query: {
        ids: idsToDelete,
      },
    };
    const queryString = stringify(queryParams, {
      arrayFormat: 'brackets',
      addQueryPrefix: true,
    });
    return this.http.delete<{ count: number }>(`${this.path}${queryString}`);
  }
}
